

const inactiveButtonClasses = "inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border shadow-xs hover:bg-gray-50 dark:bg-transparent dark:border-input dark:hover:bg-input/50 py-2 has-[>svg]:px-3 h-9 rounded-md px-3 bg-white";
const activeButtonClasses = "inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border py-2 has-[>svg]:px-3 h-9 rounded-md px-3 bg-primary text-primary-foreground hover:bg-primary/90 text-white";

export const LogStateButtonsTable = ({
    selectedLogStatus,
    setSelectedLogStatus,
}) => {
    return (
        <div className="mt-3 flex flex-wrap gap-2">
            <button
                className={`${selectedLogStatus === "all" ? activeButtonClasses : inactiveButtonClasses}`}
                onClick={() => setSelectedLogStatus("all")}
            >
                All
            </button>
            <button
                className={`${selectedLogStatus === "approved" ? activeButtonClasses : inactiveButtonClasses}`}
                onClick={() => setSelectedLogStatus("approved")}
            >
                Approved
            </button>
            <button
                className={`${selectedLogStatus === "dismissed" ? activeButtonClasses : inactiveButtonClasses}`}
                onClick={() => setSelectedLogStatus("dismissed")}
            >
                Dismissed
            </button>
        </div>
    )
}